



import Page from '../attendance/attendances/myPersonholiday.vue'
export default {
  name: 'myAttendanceRecord',
  components: { Page },
}
